/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const GitHubConnectionProviderId = "ms.vss-admin-web.org-admin-githubconnection-data-provider";

export interface GitHubConnectionData {
    collectionId?: string;
    canLink: boolean;
    inviteSet?: boolean;
    organizationName: string;
    isAadConnected?: boolean;
    gitHubConnectUrl?: string;
    isGitHubConnected: boolean;
}

export function getGitHubConnectionData(pageContext: IVssPageContext): Promise<GitHubConnectionData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<GitHubConnectionData>(GitHubConnectionProviderId).then(result => {
        return result;
    });
}
